export interface IGoogleMapPopupEvents {
  open: undefined;
  close: undefined;
  lonLatChange: undefined;
}
